<template>
    <div class="xx-form-panel">
        <div class="title clearfix" :style="titleStyle">
            <div class="pull-left" :style="{ width: $slots.operator ? 'auto' : '100%' }">
                <span>{{ title }}</span>
                <!-- @slot 自定义title -->
                <slot name="title"></slot>
            </div>
            <div class="operator pull-right">
                <!-- @slot 放在title右侧的内容, 比如下载按钮 -->
                <slot name="operator"></slot>
            </div>
        </div>
        <div class="content">
            <!-- @slot 内容区域 -->
            <slot></slot>
        </div>
    </div>
</template>

<script>
/**
 *  @author lvxin08
 *  @since 1.3.2
 *
 *  panel，对标el-card
 */
export default {
    name: 'XxPanel',
    props: {
        /**
         *  title
         */
        title: {
            type: String,
            default: ''
        },
        /**
         *  title的高度，默认是40px
         */
        titleHeight: {
            type: Number,
            default: 40
        },
        /**
         *  title样式，style Object
         */
        titleStyle: {
            type: Object,
            default: null
        }
    }
};
</script>

<style lang="scss" scoped>
.xx-form-panel {
    background: #fff;
    .title {
        background: #f7f7f7;
        color: #000;
        font-size: 14px;
        font-weight: bold;
        padding: 5px 10px;
        line-height: 30px;
        border-bottom: 1px solid #eee;
        .operator {
            font-weight: normal;
        }
    }
    .content {
        border-bottom: 1px solid #eee;
        padding: 10px;
        &:empty {
            display: none;
        }
    }
    & {
        border: 1px solid #f7f7f7;
        & &:not(:first-child) {
            margin-top: -1px;
        }
        .title,
        .content {
            border-bottom: 0;
        }
    }
}
</style>
